
import React, { useState, useEffect } from "react";
import PosInvoiceTable from "./PosInvoiceTable.js";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import useFormattingUtils from "../../../../../context/useFormattingUtils.js";

export default function PosInvoiceData() {
  const { GetPaginatedData } = useApi();
  const { formatDate } = useFormattingUtils();
  const [loading, setLoading] = useState(false);
  const [salesInvoiceData, setSalesInvoiceData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // Optionally add searchTerm and sort state here

  useEffect(() => {
    fetchSalesInvoiceData({ page });
  }, [page]);

  const fetchSalesInvoiceData = async ({ page = 1, searchTerm = "", sort = "" } = {}) => {
    const trimmedSearchTerm = searchTerm.trim();
    try {
      setLoading(true);
      const response = await GetPaginatedData("getProductPosInvoice", {
        page,
        search: trimmedSearchTerm || undefined,
        queryParams: {
          ...(sort && { sort }),
        },
      });
      const results = response?.data || [];
      const totalPages = Math.ceil((response?.totalCount || 0) / 10) || 1;
      const formatted = results.map((item) => ({
        ...item,
        date: item.date ? formatDate(item.date) : "N/A",
      }));
      setSalesInvoiceData(formatted);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Error fetching sales invoice data:", error);
      setSalesInvoiceData([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "invoice_no", header: "Invoice No" },
    { field: "final_after_discount", header: "Amount" },
    { field: "pay_method", header: "Payment Type" },
    { field: "date", header: " Invoice Date" },
  ];
 const renderPagination = () => {
    const pages = [];
    const maxPages = 5;
    let start = Math.max(1, page - Math.floor(maxPages / 2));
    let end = Math.min(totalPages, start + maxPages - 1);
    if (end - start < maxPages) {
      start = Math.max(1, end - maxPages + 1);
    }
    for (let i = start; i <= end; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${page === i ? "active" : ""}`}
        >
          <a className="page-link" href="#" onClick={() => setPage(i)}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  return (
    <div className="main-container">
      <div className="">
        <div className="">
          <div>
            <PosInvoiceTable
              data={salesInvoiceData}
              showFooter={true}
              columns={columns}
              showAction={true}
              loading={loading}
            />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>

              {/* <nav>
                <ul className="pagination" style={{border:"none"}}>{renderPagination()}</ul>
              </nav> */}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
